import { useCallback } from 'react';
import { Controller, Control } from 'react-hook-form';
import _ from 'lodash';
import AsyncSelect from 'react-select/async';

import classes from './FormAutocomplete.module.css';

export type SelectInputOption = {
  value: string;
  label: string;
}

interface SelectInputProps {
  name: string;
  label: string;
  className?: string;
  control: Control;
  defaultValue: any
  isMulti?: boolean;
  disabled?: boolean;
  inline?: boolean;
  loadItems: (inputValue: string) => Promise<any[]>;
}

export const SelectAutocomplete = ({
  name, label, className, control,
  defaultValue, isMulti, disabled,
  inline, loadItems
}: SelectInputProps) => {
  const fetchOptions = async (inputValue: string) => {
    if (!inputValue) return [];

    return loadItems(inputValue);
  };

  const loadOptions = useCallback(_.debounce(fetchOptions, 500), []);

  return (
    <Controller
      control={control}
      defaultValue={defaultValue}
      name={name}
      render={({ field: { onChange, value, ref }}) => (
        <div className={`${inline ? classes.inlineContainer : classes.container} ${className || ''}`}>
          <label
            className={classes.label}
            htmlFor={name}
          >{label}</label>
          <AsyncSelect
            value={value}
            onChange={(value: SelectInputOption) => {
              onChange(value);
            }}
            loadOptions={loadOptions}
            isMulti={isMulti}
            disabled={disabled}
            styles={{
              control: (baseStyles: any, state: any) => ({
                ...baseStyles,
                fontSize: '14px',
                borderColor: '#ccc',
                // borderRadius: '10px',
                // paddingTop: '3px',
                // paddingBottom: '3px',
                // To disable the blue border
                // See https://stackoverflow.com/questions/52614304/react-select-remove-focus-border
                boxShadow: 'none',
                textAlign: 'start'
              }),
              option: (baseStyles: any, state: any) => ({
                ...baseStyles,
                // See https://stackoverflow.com/questions/73939936/react-select-how-to-change-the-font-size-on-on-the-dropdown-menu
                fontSize: '14px',
                textAlign: 'start'
              })
            }}
          />
        </div>
      )}
    />
  );
};
